//login constants
export const SHOW_LOGIN_LOADER = "SHOW_LOGIN_LOADER";
export const SET_LOGIN_SUCCESS = "SET_LOGIN_SUCCESS";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";

//all building constants

export const SET_ALL_BUILDING_DATA = "SET_ALL_BUILDING_DATA";

export const SET_DEVICES_DATA = "SET_DEVICES_DATA";
export const SET_FLAT_DATA = "SET_FLAT_DATA";
